import { css } from "lit";
//#region src/pd-history/history-footer-styles.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
/**
* Meta-footer look for an object history behind a pd-collapse: visually
* light (no primary bar, no shadow), separated from the content above by
* a hairline. The collapsed header splits into a passive status part and
* a visible ACTION — a muted one-liner alone reads as a caption, not as
* something clickable (tester feedback 2026-08-17). The expanded list
* gets a subtle left guide line.
*
* Usage: add this CSSResult to the consuming component's static styles,
* put class "pd-history-footer" on the pd-collapse that wraps the
* pd-history-list, and structure the header slot as
*
*   <div slot="header" class="history-teaser">
*     <span class="history-status">(icon) Zuletzt bearbeitet …</span>
*     <span class="history-action">Historie anzeigen</span>
*   </div>
*
* The whole line stays the collapse trigger; the link-styled action is
* the affordance, and the collapse's standard toggle icon sits directly
* next to it (the action is the last header element). Deliberately a
* shared style, not a component (rule of two).
*/
var HistoryFooterStyles = css`
  .pd-history-footer {
    display: block;
    margin-top: var(--pd-spacing-md, 1rem);
    border-top: 1px solid var(--pd-default-light-col, #e0e0e0);
    padding-top: var(--pd-spacing-sm, 0.5rem);

    --pd-collapse-bg-col: transparent;
    --pd-collapse-header-shadow: none;
    --pd-collapse-hover-col: var(--pd-default-bg-light-col, #f4f6fa);
    --pd-collapse-hover-font-col: var(--pd-default-font-muted-col, #757575);
    --pd-collapse-font-col: var(--pd-default-font-muted-col, #757575);
    --pd-collapse-header-font-size: 0.9rem;
    --pd-collapse-content-bg-col: transparent;
    --pd-collapse-content-border-col: transparent;
  }

  .pd-history-footer .history-teaser {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    flex-wrap: wrap;
    min-width: 0;
  }

  .pd-history-footer .history-status {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    min-width: 0;
  }

  /* The action: link-styled, chevron coupled directly to the label. */
  .pd-history-footer .history-action {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    white-space: nowrap;
    color: var(
      --pd-history-footer-action-col,
      var(--pd-default-font-link-col, #067394)
    );
  }

  .pd-history-footer:hover .history-action {
    text-decoration: underline;
  }

  .pd-history-footer pd-history-list {
    border-left: 2px solid var(--pd-default-light-col, #e0e0e0);
    padding-left: var(--pd-spacing-md, 1rem);
  }
`;
//#endregion
export { HistoryFooterStyles };
